<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('leaveInitialBalance.leaveInitialBalance') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loadingPreData">
        <form>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">
                  {{ $t('leaveInitialBalance.employeeName') }}
                </label>
                <div>
                  <ts-search-select
                    disabled
                    v-model="model.employee_id"
                    :options="
                      employees.map(emp => ({
                        value: emp.employee_id,
                        text: emp.employee_name_en + ' | ' + emp.employee_name_kh
                      }))
                    "
                  />
                  <div class="invalid-feedback" v-if="errors.has('emp_type_id')">
                    {{ errors.first('emp_type_id') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">
                  {{ $t('leaveInitialBalance.leaveType') }}
                </label>
                <div>
                  <ts-search-select
                    disabled
                    v-model="model.leave_type_id"
                    :options="
                      leaveTypes.map(e => ({
                        text: e.leave_type_en + '|' + e.leave_type_kh,
                        value: e.leave_type_id
                      }))
                    "
                    :class="{ 'is-invalid': errors.has('leave_type_id') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('leave_type_id')">
                    {{ errors.first('leave_type_id') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">
                  {{ $t('leaveInitialBalance.adjustment') }}
                </label>
                <div>
                  <ts-input
                    type="number"
                    v-model.number="model.adjustment"
                    :class="{ 'is-invalid': errors.has('adjustment') }"
                  ></ts-input>
                  <div class="invalid-feedback" v-if="errors.has('adjustment')">
                    {{ errors.first('adjustment') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">
                  {{ $t('leaveInitialBalance.carryForward') }}
                </label>
                <div>
                  <ts-input
                    type="number"
                    :class="{ 'is-invalid': errors.has('carry_forward') }"
                    v-model.number="model.carry_forward"
                  ></ts-input>
                  <div class="invalid-feedback" v-if="errors.has('carry_forward')">
                    {{ errors.first('carry_forward') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">
                  {{ $t('leaveInitialBalance.carryForwardClearDate') }}
                </label>
                <div>
                  <ts-date-picker-input
                    format="DD-MM-YYYY"
                    :class="{ 'is-invalid': errors.has('carry_forward_clear_date') }"
                    v-model="model.carry_forward_clear_date"
                  ></ts-date-picker-input>
                  <div class="invalid-feedback" v-if="errors.has('carry_forward_clear_date')">
                    {{ errors.first('carry_forward_clear_date') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row ts-mt-6">
            <div class="col-sm-12 col-lg-12 col-md-12 text-right">
              <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
              <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="save">{{
                $t('button.update')
              }}</ts-button>
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  props: ['editData', 'year'],
  name: 'leave-initial-balance-form',
  data() {
    return {
      model: {
        leave_initial_balance_id: '',
        employee_id: '',
        leave_type_id: '',
        adjustment: '',
        carry_forward: '',
        carry_forward_clear_date: ''
      },
      dateGenerate: {
        year: ''
      },
      errors: new Errors(),
      saving: false,
      savingAndNew: false,
      loadingPreData: true
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('hr/leaveInitialBalance', ['employees', 'leaveTypes'])
  },
  methods: {
    ...mapActions('hr/leaveInitialBalance', ['fetchEmployees']),

    async fetchResourceBeforeCreate() {
      await Promise.all([this.fetchEmployees()]).then(responses => {})
      await this.$store
        .dispatch('hr/leaveInitialBalance/dataBeforeCreate')
        .then(response => {
          this.loadingPreData = false
          this.setData()
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },

    submit() {
      let responseResult

      this.errors = new Errors()

      responseResult = this.$store.dispatch('hr/leaveInitialBalance/update', this.model)

      return responseResult
        .then(response => {
          return this.$store.dispatch('hr/leaveInitialBalance/fetch', this.dateGenerate).then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)

          return Promise.reject(error)
        })
    },
    save() {
      this.saving = true

      this.submit()
        .then(() => {
          this.$emit('close')
        })
        .finally(() => {
          this.saving = false
        })
    },
    setData() {
      if (!_.isEmpty(this.editData)) {
        this.dateGenerate.year = this.year
        this.model = {
          leave_initial_balance_id: this.editData.leave_initial_balance_id,
          employee_id: this.editData.employee_id,
          leave_type_id: this.editData.leave_type_id,
          adjustment: this.editData.adjustment,
          carry_forward: this.editData.carry_forward,
          carry_forward_clear_date: this.editData.carry_forward_clear_date
        }
      }
    },
    cancel() {
      this.model = {
        leave_initial_balance_id: '',
        employee_id: '',
        leave_type_id: '',
        adjustment: '',
        carry_forward: '',
        carry_forward_clear_date: ''
      }
    }
  }
}
</script>
